import React, { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

/* -------------------------------------------------
   Lazy‑loaded page components
   ------------------------------------------------- */
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const HistoryPage = lazy(() => import('../pages/about/history/page'));
const LevelClassPage = lazy(() => import('../pages/about/level-class/page'));
const SmallClassPage = lazy(() => import('../pages/about/small-class/page'));
const ManagementPage = lazy(() => import('../pages/about/management/page'));
const ScholarshipPage = lazy(() => import('../pages/about/scholarship/page'));
const CurriculumPage = lazy(() => import('../pages/curriculum/page'));
const MathCurriculumPage = lazy(() => import('../pages/curriculum/math/page'));
const EnglishCurriculumPage = lazy(() => import('../pages/curriculum/english/page'));
const KoreanCurriculumPage = lazy(() => import('../pages/curriculum/korean/page'));
const ScienceCurriculumPage = lazy(() => import('../pages/curriculum/science/page'));
const WinterSchoolPage = lazy(() => import('../pages/curriculum/winter-school/page'));
const TeachersPage = lazy(() => import('../pages/teachers/page'));
const ResultsPage = lazy(() => import('../pages/results/page'));
const AdmissionResultsPage = lazy(() => import('../pages/results/admission/page'));
const SchoolResultsPage = lazy(() => import('../pages/results/school/page'));
const NoticePage = lazy(() => import('../pages/notice/page'));
const NoticeAdminPage = lazy(() => import('../pages/notice/admin/page'));
const NoticeDetailPage = lazy(() => import('../pages/notice/detail/page'));
const FaqPage = lazy(() => import('../pages/news/faq/page'));
const ReviewsPage = lazy(() => import('../pages/news/reviews/page'));
const CampusPage = lazy(() => import('../pages/campus/page'));
const JihangCampusPage = lazy(() => import('../pages/campus/jihang/page'));
const OkjeongCampusPage = lazy(() => import('../pages/campus/okjeong/page'));
const MillakCampusPage = lazy(() => import('../pages/campus/millak/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

/* -------------------------------------------------
   Route definitions
   ------------------------------------------------- */
const routes: RouteObject[] = [
  { 
    path: '/', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <HomePage />
      </Suspense>
    )
  },
  { 
    path: '/about', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <AboutPage />
      </Suspense>
    )
  },
  { 
    path: '/about/history', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <HistoryPage />
      </Suspense>
    )
  },
  { 
    path: '/about/scholarship', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <ScholarshipPage />
      </Suspense>
    )
  },
  { 
    path: '/about/level-class', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <LevelClassPage />
      </Suspense>
    )
  },
  { 
    path: '/about/small-class', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <SmallClassPage />
      </Suspense>
    )
  },
  { 
    path: '/about/management', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <ManagementPage />
      </Suspense>
    )
  },
  { 
    path: '/curriculum', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <CurriculumPage />
      </Suspense>
    )
  },
  { 
    path: '/curriculum/math', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <MathCurriculumPage />
      </Suspense>
    )
  },
  { 
    path: '/curriculum/english', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <EnglishCurriculumPage />
      </Suspense>
    )
  },
  { 
    path: '/curriculum/korean', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <KoreanCurriculumPage />
      </Suspense>
    )
  },
  { 
    path: '/curriculum/science', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <ScienceCurriculumPage />
      </Suspense>
    )
  },
  { 
    path: '/curriculum/winter-school', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <WinterSchoolPage />
      </Suspense>
    )
  },
  { 
    path: '/teachers', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <TeachersPage />
      </Suspense>
    )
  },
  { 
    path: '/results', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <ResultsPage />
      </Suspense>
    )
  },
  { 
    path: '/results/admission', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <AdmissionResultsPage />
      </Suspense>
    )
  },
  { 
    path: '/results/school', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <SchoolResultsPage />
      </Suspense>
    )
  },
  { 
    path: '/notice', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <NoticePage />
      </Suspense>
    )
  },
  { 
    path: '/notice/admin', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <NoticeAdminPage />
      </Suspense>
    )
  },
  { 
    path: '/notice/:id', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <NoticeDetailPage />
      </Suspense>
    )
  },
  { 
    path: '/news/faq', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <FaqPage />
      </Suspense>
    )
  },
  { 
    path: '/news/reviews', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <ReviewsPage />
      </Suspense>
    )
  },
  { 
    path: '/campus', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <CampusPage />
      </Suspense>
    )
  },
  { 
    path: '/campus/jihang', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <JihangCampusPage />
      </Suspense>
    )
  },
  { 
    path: '/campus/okjeong', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <OkjeongCampusPage />
      </Suspense>
    )
  },
  { 
    path: '/campus/millak', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <MillakCampusPage />
      </Suspense>
    )
  },
  { 
    path: '/contact', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <ContactPage />
      </Suspense>
    )
  },
  { 
    path: '*', 
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <NotFound />
      </Suspense>
    )
  },
];

export default routes;
